import React from 'react';
import { assets } from '../assets/assets';

export default function LoadingBox(props) {
  return (
    <div className={`loader-wrapper ${props.small ? 'small' : ''}`}>
      <div className="loader-container">
        <div className="loader-dial"></div>
        <img src={assets.bottom_logo} alt="Loading..." className="loader-logo-img" />
      </div>
      <div className="loader-text">Loading...</div>
    </div>
  );
}
